export default __webpack_public_path__ + "static/media/trend_down.2998bdc0.svg";